// Retourne les infos de palier de collection basées sur le nombre de sans-fautes.
// Utilisé sur le dashboard élève + confetti au moment de débloquer un nouveau palier.
// NOTE Tailwind : on utilise des classes STATIQUES car les classes dynamiques
// (`border-${p.color}-500`) ne sont pas générées par le JIT.
export const PALIERS = [
  { threshold: 1,  name: 'Novice',   emoji: '🌱', bgTile: 'bg-emerald-500/15', borderTile: 'border-emerald-500/40', bar: 'from-emerald-500 to-emerald-400', text: 'text-emerald-200' },
  { threshold: 3,  name: 'Curieux',  emoji: '🎯', bgTile: 'bg-sky-500/15',     borderTile: 'border-sky-500/40',     bar: 'from-sky-500 to-sky-400',         text: 'text-sky-200' },
  { threshold: 5,  name: 'Habile',   emoji: '⚡', bgTile: 'bg-violet-500/15',  borderTile: 'border-violet-500/40',  bar: 'from-violet-500 to-violet-400',   text: 'text-violet-200' },
  { threshold: 10, name: 'Expert',   emoji: '🎖', bgTile: 'bg-amber-500/15',   borderTile: 'border-amber-500/40',   bar: 'from-amber-500 to-amber-400',     text: 'text-amber-200' },
  { threshold: 20, name: 'Champion', emoji: '🏆', bgTile: 'bg-orange-500/20',  borderTile: 'border-orange-500/50',  bar: 'from-orange-500 to-orange-400',   text: 'text-orange-200' },
  { threshold: 50, name: 'Légende',  emoji: '👑', bgTile: 'bg-rose-500/20',    borderTile: 'border-rose-500/50',    bar: 'from-rose-500 to-rose-400',       text: 'text-rose-200' },
];

export function currentPalier(perfectCount) {
  let cur = null;
  for (const p of PALIERS) {
    if (perfectCount >= p.threshold) cur = p; else break;
  }
  return cur;  // null si < 1
}

export function nextPalier(perfectCount) {
  for (const p of PALIERS) {
    if (perfectCount < p.threshold) return p;
  }
  return null;  // toutes atteintes
}

// Petit helper pour vibration mobile (haptic feedback). No-op sur desktop.
export function haptic(pattern = 15) {
  try {
    if (typeof navigator !== 'undefined' && navigator.vibrate) {
      navigator.vibrate(pattern);
    }
  } catch (_) { /* silent */ }
}
